module.exports = __webpack_public_path__ + "static/pitch-3e6480890ddc52743818f93dc395d15b.jpeg";